module.exports = __webpack_public_path__ + "img/p1-desc@2x.21d6354f.jpg";